import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.SILABALON;

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  HOME: 'HOME',
  LOADING: 'LOADING',
  INSTRUCTION: 'INSTRUCTION',
  PRACTICE: 'PRACTICE',
  ONBOARDING: 'ONBOARDING',
  REPEAT_ONBOARDING: 'REPEAT_ONBOARDING',
};

export const REPEAT_ONBOARDING_LEVEL_ID = -1;

export const NUM_LEVELS = 30;

export const NUM_PRACTICE_ANSWER_SLOTS = 4;

export const VOWEL_LEVEL = 18;

export const VOWEL_LETTER_LEVEL = 19;

export const LEVELS_WITHOUT_ONBOARDING = [VOWEL_LEVEL, VOWEL_LETTER_LEVEL];

export const SLIDE_DIRECTIONS = {
  SLIDE_UP: 'Up',
  SLIDE_DOWN: 'Down',
};

// reference for calculating mastery
export const MASTERY_PERCENTAGE = 0.8;

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  INCREMENT_PROGRESS: 'INCREMENT_PROGRESS',
  UPDATE_CURRENT_LEVEL: 'UPDATE_CURRENT_LEVEL',
  UPDATE_HIGHEST_LIST_VIEW: 'UPDATE_HIGHEST_LIST_VIEW',
  SET_MASTERY: 'SET_MASTERY',
  UPDATE_PRACTICE_ROUND: 'UPDATE_PRACTICE_ROUND',
  INTERRUPT_STANDARD_ROUND: 'INTERRUPT_STANDARD_ROUND',
  COMPLETE_STANDARD_ROUND: 'COMPLETE_STANDARD_ROUND',
  UPDATE_ONBOARDING_METADATA: 'UPDATE_ONBOARDING_METADATA',
  QUICK_ROUND: 'QUICK_ROUND',
  SET_IS_DRAGGING: 'SET_IS_DRAGGING',
};

export const ANIM_STATES = {
  READY: 'ready',
  TALKING: 'talking',
  CORRECT: 'correct',
  INCORRECT_1: 'incorrect1',
  INCORRECT_2: 'incorrect2',
};

// a collection of frame references for dog animation
export const FRAMES = {
  [ANIM_STATES.READY]: { name: ANIM_STATES.READY, frames: [30, 89], shouldLoop: true }, // default; time 2000ms
  [ANIM_STATES.TALKING]: { name: ANIM_STATES.TALKING, frames: [0, 29], shouldLoop: false }, // talking; time 1000ms
  [ANIM_STATES.CORRECT]: { name: ANIM_STATES.CORRECT, frames: [120, 180], shouldLoop: false }, // bicycle kick to goal; time 2000ms
  [ANIM_STATES.INCORRECT_1]: { name: ANIM_STATES.INCORRECT_1, frames: [90, 119], shouldLoop: false }, // kick ball back, shrug; time 1000ms
  [ANIM_STATES.INCORRECT_2]: { name: ANIM_STATES.INCORRECT_2, frames: [180, 218], shouldLoop: false }, // kick ball back, fall; time 1300ms
};

export const FONT_COLORS = {
  BLUE: '#5239EF',
  WHITE: '#FFFFFF',
};

export const BALL_DEFAULT = { image: 'ballDefault', textColor: FONT_COLORS.BLUE };

export const BALL_VARIETIES = [
  { image: 'ballWhiteBlue', textColor: FONT_COLORS.BLUE },
  { image: 'ballWhiteRed', textColor: FONT_COLORS.BLUE },
  { image: 'ballTeal', textColor: FONT_COLORS.BLUE },
  { image: 'ballPink', textColor: FONT_COLORS.BLUE },
  { image: 'ballBlue', textColor: FONT_COLORS.WHITE },
  { image: 'ballYellowBlue', textColor: FONT_COLORS.BLUE },
  { image: 'ballRedYellow', textColor: FONT_COLORS.WHITE },
];
